import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { useAppColors } from '../../hooks/useAppColors';
import { useTranslation } from 'react-i18next';

interface Props {
  message?: string;
}

export default function LoadingIndicator({ message }: Props) {
  const { t } = useTranslation();
  const colors = useAppColors();
  const displayMessage = message ?? t('common.loading');

  return (
    <View style={[styles.container, { backgroundColor: colors.bg }]}>
      <ActivityIndicator size="large" color={colors.textSecondary} />
      <Text style={[styles.text, { color: colors.textTertiary }]}>
        {displayMessage}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  text: {
    marginTop: 12,
    fontSize: 14,
  },
});
